<template>
	<div class="wrapper wrapper-content animated fadeInRight">
		<div class="row">
			<div class="col-lg-12">
				<div class="ibox float-e-margins">
					<div class="ibox-title">
						<h4>
							Whitelists settings:
						</h4>
					</div>
					<div class="ibox-content">
						<div class="row">
							<div class="enswitch-form-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
								<form name="editCRMUserForm" novalidate="" class="" @submit.prevent="save()"
									v-if="!loading">

									<div class="row form-group topZindex">
										<span
											class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label importantColor">Number:</span>
										<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
											<input type="number" name="number" id="number" v-model="number">
										</div>
									</div>

									<div class="row form-group middleZindx">
										<span
											class="col-lg-5 col-md-5 col-sm-5 col-xs-12 importantColor ">Description:</span>
										<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
											<input type="text" name="description" id="description"
												v-model="description">
											<small class="ml-3">(Optional)</small>
										</div>
									</div>

									<div class="row form-group middleZindx">
										<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 importantColor ">Expiration
											date:</span>
										<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
											<input type="text" name="expire_date" id="expire_date"
												v-model="expire_date">
											<small class="ml-3">(Optional, format: 2018-05-30)</small>
										</div>
									</div>

									<hr>
									<div class="row submit-button-container">
										<button type="submit" :disabled="sendInProgress || !number" ref="submitbtn"
											class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt"
											data-style="zoom-out" data-spinner-size="24" data-size="s"
											data-spinner-color="white" style="display: block;">
											<span class="ladda-label">Save</span>
											<span class="fas fa-spinner fa-pulse"></span>
											<div class="ladda-progress" style="width: 0px"></div>
										</button>
									</div>
								</form>
							</div>
						</div>
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ng-scope" style="margin-bottom: 8px;"
							ng-if="options.showProgress">
							<div v-if="loading" class="sk-spinner sk-spinner-wave ng-scope" ng-if="options.showProgress"
								style="display: block;">
								<div class="sk-rect1"></div>
								<div class="sk-rect2"></div>
								<div class="sk-rect3"></div>
								<div class="sk-rect4"></div>
								<div class="sk-rect5"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {WhitelistsApiService} from "../../services/WhitelistsApiService";
export default {
	props: ["routeData"],
	data: () => ({
		loading: false,
		sendInProgress: false,
		number: null,
		description: null,
		expire_date: null
	}),
	created() {
		let $injector = this.$root.angularInjector;
		let CoreApiService = $injector.get("CoreApiService");
		this.WhitelistsApiService = new WhitelistsApiService(CoreApiService);
		this.SwalService = $injector.get("SwalService");
	},
	async mounted() {
		this.loading = true;
		this.items = await this.WhitelistsApiService.list();
		this.loading = false;
	},
	watch: {
		sendInProgress: function(val) {
			if (val) {
				this.$refs.submitbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.submitbtn.dataset.loading;
			}
		}
	},
	methods: {
		async save() {
			this.sendInProgress = true;
			try {
				await this.WhitelistsApiService.create({number: this.number, description: this.description, expire_date: this.expire_date})
					.then(res => {
						this.SwalService.popup({
							title: "Success!",
							text: res.data.updated > 0 ? (res.data.updated + " whitelist updated!") : (res.data.created + " whitelist saved!")
						}).then(f => {
							this.$router.replace("/list");
						});
					});
			}
			catch (e) {
				console.log(e);
				this.SwalService.popup({
					title: getErrorMessage(e),
					type: "error",
					text: e.data
				});
			}
			finally {
				this.sendInProgress = false;
			}
		}
	}
};

function getErrorMessage(e) {
	if (e.message == "Bad request") {
		if (e.key == "error_username_in_use") {
			return "Duplicate username";
		}
		else if (e.key == "error_email_exists") {
			return "Duplicate email";
		}
	}
	else if (e.code === 409) {
		return "Number already exist!";
	}
	return e.message || e.statusText || e || "Error";
}
</script>

<style lang="scss" scoped>
.importantColor {
	color: #732;
	font-weight: bold;
	padding: 5px;
}

.my-class /deep/ .dropdown-menu {
	max-height: 240px;
	overflow-y: auto;
	transform: unset !important;
	left: 0%;
}

.my-class /deep/ a {
	padding: 1px !important;
	margin: 1px !important;
	line-height: 20px !important;
}

.ibox-content /deep/ ul {
	width: 250px !important;
}

.behindZindex {
	z-index: 0 !important;
}

.middleZindx {
	z-index: 3 !important;
}

.topZindex {
	z-index: 5 !important;
}

.btn-width {
	width: 10% !important;
}

.outNumberContainer {
	display: flex;
	flex-direction: row;
	margin-bottom: 5px;

	p {
		width: 50%;
		text-align: right;
		align-self: end;
	}

	button {
		max-width: 80px;
	}
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}
</style>>